import React, { Component } from 'react';
import Grid from 'material-ui/Grid';
import './index.scss';
import Input, { InputLabel } from 'material-ui/Input';
import Button from 'material-ui/Button';
import { FormControl } from 'material-ui/Form';
import Divider from 'material-ui/Divider';
import {evArea, evTitle, evImg, evText, evButton, noEvButton, selectEvButton} from "./evStyle";

import { withStyles } from 'material-ui/styles';

import {observer,inject} from 'mobx-react';
import {gotoProject, gotoProjectButton} from "../../constants/theme";


const styles = theme => ({
    textFieldInput : {
        fontSize : 18,
        color: '#FAFAFA',
        fontFamily: 'DB Heavent Li'
    },
    textFieldFormLabel : {
        fontSize : 17,
        color: '#FAFAFA',
        fontFamily: 'DB Heavent Li'
    },
    text: {
        fontSize : 17,
        fontFamily: 'DB Heavent Li'
    },
});

const lineInfoStyle = {paddingBottom:'10px'}; //{lineHeight:2.5,paddingTop:'1.5%'};

@inject("summaryDataStore")
@observer
class CalMoney extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: 25,
            interest: 6,
        };
    }

    componentDidMount(){
        const { year, interest } = this.state;
        // setYearAndMonth(year,interest)
        this.props.summaryDataStore.setYearAndMonth(year,interest);
        this.props.summaryDataStore.calPerMonth(year,interest);
    }

    handleChange = event => {
        const {year,interest} = this.state;
        let {id,value} = event.target;
        value = value.substr(0, 2);
        switch (id){
            case 'year':
                this.setState({ year: value });
                this.props.summaryDataStore.setYearAndMonth(value,interest);
                this.props.summaryDataStore.calPerMonth(value,interest);
                break;
            case 'interest':
                this.setState({ interest: value });
                this.props.summaryDataStore.setYearAndMonth(year,value);
                this.props.summaryDataStore.calPerMonth(year,value);
                break;
            default:
        }
    }

    selectEvOrNot = (name) => {
        const { year, interest } = this.state;
        if(name === 'add') {
            this.props.summaryDataStore.setEVSelect(false);
        } else {
            this.props.summaryDataStore.setEVSelect(true);
        }
        this.props.summaryDataStore.calPerMonth(year,interest);
    }

    render() {
        const { year, interest } = this.state;
        const { classes } = this.props;
        const {
                project,
                plan,
                isEvSelect,
                homeCostPerMonth,
                solarCostPerMonth,
                evCostPerMonth,
                powerGenerationSelected,
                additionalSelected,
                beginPrice,
                sumCost,
                sumCostPerMonth,
                subType
            } = this.props.summaryDataStore;
        // const additionalPrice = this.props.summaryDataStore.calPriceOfSolar(powerGenerationSelected);
        let nameDefaultPackage = 'ติดตั้งฟรีพร้อมบ้าน';
        if(subType !== 'บ้านเดี่ยว') {
            nameDefaultPackage = 'ติดตั้งฟรีพร้อมโครงการ';
        }
        return (
            <div className="calMoney">
                <Grid container className='containerGrid' spacing={0}>
                    <Grid xs={12} sm={7} md={7} className='leftZone' >
                        <Grid container className='containerGrid' spacing={0}>
                            {/* <Grid xs={1} sm={1} md={2} > </Grid>
                            <Grid xs={10} sm={10} md={9} > */}
                            <Grid xs={1} className="space"> </Grid>
                            <Grid xs={10} className="gridMoney">
                                <div class="divCalMoney">
                                    <h2 className='headerMoney'>คำนวณอัตราการผ่อน</h2>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span className='sumCost'>ราคาบ้าน</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right'}}>
                                                <span className='sumCost'> { this.props.summaryDataStore.format_(beginPrice) } บาท</span>
                                                &nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span className='sumCost'>ราคาอุปกรณ์โซลาร์เซลล์ ขนาด { powerGenerationSelected } kWp</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right'}}>
                                                <span className='sumCost'>
                                                    {
                                                        solarCostPerMonth === 0 ? nameDefaultPackage : this.props.summaryDataStore.format_(additionalSelected)+' บาท'
                                                    }
                                                </span>
                                                &nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <InputLabel htmlFor="year" className={classes.textFieldFormLabel}>ระยะเวลา</InputLabel>
                                        <Input id="year"
                                            fullWidth
                                            type="number"
                                            inputProps={{maxLength: 2}}
                                            value={year}
                                            className={classes.textFieldInput}
                                            endAdornment={<div className="endInput" >ปี</div>}
                                            onChange={this.handleChange} />
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <InputLabel htmlFor="interest" className={classes.textFieldFormLabel}>อัตราดอกเบี้ยต่อปี</InputLabel>
                                        <Input id="interest"
                                            fullWidth
                                            type='number'
                                            value={interest}
                                            className={classes.textFieldInput}
                                            endAdornment={<div className="endInput" >%</div>}
                                            onChange={this.handleChange} />
                                    </FormControl>

                                    <FormControl className='inputLeftZone' style={evArea}>
                                        <Grid container className='containerGrid'spacing={0}>
                                            <Grid xs={12} sm={12} md={12} >
                                                <div style={evTitle}>
                                                    <img alt='EV' src='assets/park_and_charge.png' style={evImg} />
                                                    &nbsp;
                                                    <span style={evText}>คุณต้องการเพิ่มอุปกรณ์ EV Charger ด้วยหรือไม่ ?</span>
                                                </div>
                                            </Grid>
                                            <Grid xs={12} sm={12} md={12} style={evButton}>
                                                <Button style={ isEvSelect ? noEvButton : selectEvButton }
                                                        onClick={() => this.selectEvOrNot()}>ไม่เพิ่ม</Button>
                                                <Button style={ isEvSelect ? selectEvButton : noEvButton }
                                                        onClick={() => this.selectEvOrNot('add')}>
                                                    <span>เพิ่ม</span>
                                                    <div> (+120,000 บาท)</div>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <br/>
                                        <Grid container className='containerGrid' spacing={0} style={lineInfoStyle}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span className='sumCost VerAlightBottom'>ราคาบ้านพร้อมอุปกรณ์ส่วนเพิ่ม</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right'}}>
                                    
                                                    <sapn className='numOfSumCost'> { this.props.summaryDataStore.format_(sumCost) } </sapn>
                                                    <span className='sumCost VerAlightBottom'> บาท </span>
                                                
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0} style={lineInfoStyle}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span className='sumCost VerAlightBottom'>อัตราการผ่อนต่อเดือน</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right'}}>
                                                
                                                    <sapn className='numOfSumCost'> { this.props.summaryDataStore.format_(sumCostPerMonth) } </sapn>
                                                    <span className='sumCost VerAlightBottom'>   บาท/เดือน </span>
                                                
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <br/>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6} >
                                                <span>รายการผ่อนชำระ</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right'}}>
                                                <span>ราคา / เดือน</span>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                        <Divider style={{backgroundColor:'#FAFAFA'}} />
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span>{ project.title }</span>
                                                <br/>
                                                <span className='recommend'>
                                                    { project.site }
                                                    { subType !== 'บ้านเดี่ยว' ? null : ' แบบแปลน '+plan.title }
                                                </span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right',lineHeight:1.75}}>
                                                {
                                                    homeCostPerMonth === 0 ?
                                                        <span>
                                                            <span className='textShow'> 0 </span>&nbsp;<span>บาท</span>
                                                        </span>
                                                        :
                                                        <span>
                                                            <span className='textShow'>{this.props.summaryDataStore.format_(homeCostPerMonth)}</span>
                                                            &nbsp;
                                                            <span>บาท</span>
                                                        </span>
                                                }
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6}>
                                                <span>อุปกรณ์โซลาร์เซลล์ ขนาด { powerGenerationSelected } kWp</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right',lineHeight:1.75}}>
                                                {
                                                    solarCostPerMonth === 0 ?
                                                        <span>
                                                            <span className='textShow'> 0 </span>&nbsp;<span>บาท</span>
                                                        </span>
                                                        :
                                                        <span>
                                                            <span className='textShow'>
                                                                { this.props.summaryDataStore.format_(solarCostPerMonth) }
                                                            </span>
                                                            &nbsp;
                                                            <span>บาท</span>
                                                        </span>
                                                }
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={6} sm={6} md={6} >
                                                <span>อุปกรณ์ EV Charger</span>
                                            </Grid>
                                            <Grid xs={6} sm={6} md={6} style={{textAlign:'right',lineHeight:1.75}}>
                                                {
                                                    evCostPerMonth === 0 ?
                                                        <span>
                                                            <span className='textShow'> 0 </span>&nbsp;<span>บาท</span>
                                                        </span>
                                                        :
                                                        <span>
                                                            <span className='textShow'>{this.props.summaryDataStore.format_(evCostPerMonth)}</span>
                                                            &nbsp;
                                                            <span>บาท</span>
                                                        </span>
                                                }
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <Divider style={{backgroundColor:'#FAFAFA',marginBottom:'3%'}} />
                                    <FormControl className='inputLeftZone'>
                                        <Grid container className='containerGrid' spacing={0}>
                                            <Grid xs={12} sm={12} md={12} >
                                                <span className='recommend'>*หมายเหตุ ผลจากการคำนวณเป็นแค่การประมาณการ</span>
                                            </Grid>
                                        </Grid>
                                    </FormControl>
                                    <br/>
                                    <br/>
                                    <div style={{display:'flex',justifyContent:'center'}}>
                                        <Button fullWidth style={gotoProjectButton} onClick={() => this.props.summaryDataStore.gotoDetailProject()} >ดูรายละเอียดโครงการ</Button>
                                    </div>
                                    <br/>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid xs={12} sm={5} md={5} style={{display:'flex',alignItems:'start',backgroundColor:'#F1F2F2'}}>
                        <img src='assets/banner_web_solar.png' alt='' style={{width:'100%'}} />
                        {/*<Grid container className='containerGrid' spacing={0}>*/}
                            {/*<Grid xs={12} sm={8} md={7} className='rightZone'>*/}
                                {/*<br/>*/}
                                {/*<img src='assets/EV_Ready.png' alt='' style={{height:90}} />*/}
                                {/*<h2 className='detailHeader'>*/}
                                    {/*โครงการแรกในไทยที่ติดตั้ง <span className='highlight'> EV Charger </span> ให้ทุกหลัง*/}
                                {/*</h2>*/}
                                {/*<div className='content'>*/}
                                    {/*<span>*/}
                                        {/*&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ทุกวันนี้โลกของเราก้าวเข้าสู่อนาคตที่ท้าทายยิ่งขึ้น ด้วยความจำเป็นและจำกัดของทรัพยากร.*/}
                                        {/*<span className='highlight'> คุณจะช่วยโลกได้อย่างไร !!! </span>*/}
                                        {/*ด้วยความก้าวล้ำของเทคโนโลยีผนวกกับการสร้างสรรค์นวัตกรรมเพื่อสร้างสิ่งทดแทน และสิ่งใหม่ที่ดีกว่า ....*/}
                                        {/*<span className='highlight'> รถยนต์ไฟฟ้า หรือ Electric Vehicle (EV) </span>*/}
                                        {/*ยานพาหนะที่จะมาตอบโจทย์โลกยุคใหม่ ซึ่งใช้พลังงานไฟฟ้าแทนการใช้น้ำมันหรือเชื้อเพลิงอื่นๆ*/}
                                        {/*ซึ่งขับเคลื่อนโดยมอเตอร์ไฟฟ้าแทนการใช้เครื่องยนต์ที่มีการเผาไหม้สันดาปภายใน รถไฟฟ้าจะใช้ไฟฟ้าเป็นแหล่งพลังงานแทนที่น้ำมันหรือเชื้อเพลิงอื่นๆ*/}
                                        {/*โดยมอเตอร์ไฟฟ้าในรถจะเปลี่ยนพลังงานไฟฟ้าจากชุดแบตเตอรี่ให้เป็นพลังงานกลเพื่อการขับเคลื่อนล้อ ส่วนระบบการชาร์จ และเครื่องชาร์จ*/}
                                        {/*<span className='highlight'> EV Charger </span>*/}
                                        {/*จะเปลี่ยนกระแสไฟฟ้ากระแสสลับเป็นกระแสตรง เพื่อป้อนให้กับแบตเตอรี่ในการเก็บพลังงาน*/}
                                    {/*</span>*/}
                                    {/*<br/>*/}
                                    {/*<p style={{color:'#616161',fontFamily:'Kanit-Regular'}}> สนใจติดตั้ง EV Charger ติดต่อ 1775</p>*/}
                                {/*</div>*/}
                            {/*</Grid>*/}
                        {/*</Grid>*/}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(CalMoney);


// WEBPACK FOOTER //
// ./src/components/footer/calMoney.js